import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import useFirestore from "../../../../config/fireBaseHook";

const DivisionsByIdDropdown = ({
  value,
  onChange,
  name = "DivisionID",
  label = "Division",
  fullWidth = true,
  margin = "normal",
  required = false,
  disabled = false,
  ...otherProps
}) => {
  const { data: divisions, loading, error } = useFirestore("Divisions");

  const handleChange = (event) => {
    if (onChange) {
      // Create a synthetic event-like object to match the expected format
      const syntheticEvent = {
        target: {
          name: name,
          value: event.target.value,
        },
      };
      onChange(syntheticEvent);
    }
  };

  // Check if current value exists in divisions
  const currentValueExists = divisions?.some((division) => {
    const divisionId =
      division.DivisionID || division.Division_Id || division.id;
    return divisionId === value;
  });

  // Get division name for current value
  const getCurrentDivisionName = () => {
    if (!value || !divisions) return value;
    const division = divisions.find((div) => {
      const divisionId = div.DivisionID || div.Division_Id || div.id;
      return divisionId === value;
    });
    if (division) {
      return (
        division.DivisionName ||
        division.Division_Name ||
        division.Name ||
        value
      );
    }
    return value;
  };

  // Sort divisions by display name (DivisionName, Division_Name, Name, id)
  const sortedDivisions = divisions
    ? divisions.slice().sort((a, b) => {
        const nameA = (
          a.DivisionName ||
          a.Division_Name ||
          a.Name ||
          a.id ||
          ""
        ).toLowerCase();
        const nameB = (
          b.DivisionName ||
          b.Division_Name ||
          b.Name ||
          b.id ||
          ""
        ).toLowerCase();
        return nameA.localeCompare(nameB);
      })
    : [];

  if (loading) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel>{label}</InputLabel>
        <Select value="" label={label} disabled {...otherProps}>
          <MenuItem value="">
            <CircularProgress size={20} />
            <span style={{ marginLeft: 8 }}>Loading...</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  if (error) {
    return (
      <FormControl fullWidth={fullWidth} margin={margin} disabled>
        <InputLabel error>{label}</InputLabel>
        <Select value="" label={label} error disabled {...otherProps}>
          <MenuItem value="">
            <span style={{ color: "red" }}>Error loading options</span>
          </MenuItem>
        </Select>
      </FormControl>
    );
  }

  return (
    <FormControl
      fullWidth={fullWidth}
      margin={margin}
      required={required}
      disabled={disabled}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value || ""}
        onChange={handleChange}
        label={label}
        name={name}
        {...otherProps}
      >
        <MenuItem value="">
          <em>Select {label}</em>
        </MenuItem>
        {value && !currentValueExists && (
          <MenuItem
            value={value}
            style={{ fontStyle: "italic", color: "#999" }}
          >
            {getCurrentDivisionName()} (Current value - not in list)
          </MenuItem>
        )}
        {sortedDivisions.map((division) => (
          <MenuItem
            key={division.id}
            value={division.DivisionID || division.Division_Id || division.id}
          >
            {division.DivisionName ||
              division.Division_Name ||
              division.Name ||
              division.id}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DivisionsByIdDropdown;
